// app/redux/reducers/attestationsReducer.js

import {
    // UI
    SET_ATTESTATIONS_LOADING,
    CLEAR_ATTESTATIONS_MESSAGE,

    // Paramétrage
    FETCH_ATTESTATIONS_SUCCESS,
    FETCH_ATTESTATIONS_FAIL,
    CREATE_ATTESTATION_SUCCESS,
    CREATE_ATTESTATION_FAIL,
    UPDATE_ATTESTATION_SUCCESS,
    UPDATE_ATTESTATION_FAIL,
    DELETE_ATTESTATION_SUCCESS,
    DELETE_ATTESTATION_FAIL,

    // Workflow
    GET_MY_ATTESTATION_REQUESTS_SUCCESS,
    GET_MY_ATTESTATION_REQUESTS_FAIL,
    CREATE_ATTESTATION_REQUEST_SUCCESS,
    CREATE_ATTESTATION_REQUEST_FAIL,
    CANCEL_ATTESTATION_REQUEST_SUCCESS,
    CANCEL_ATTESTATION_REQUEST_FAIL,
    UPDATE_ATTESTATION_REQUEST_SUCCESS,
    UPDATE_ATTESTATION_REQUEST_FAIL,

    GET_MANAGER_ATTESTATION_INBOX_SUCCESS,
    GET_MANAGER_ATTESTATION_INBOX_FAIL,
    GET_MANAGER_ATTESTATION_HISTORY_SUCCESS,
    GET_MANAGER_ATTESTATION_HISTORY_FAIL,
    MANAGER_ATTESTATION_DECISION_SUCCESS,
    MANAGER_ATTESTATION_DECISION_FAIL,

    GET_ADMIN_ATTESTATION_INBOX_SUCCESS,
    GET_ADMIN_ATTESTATION_INBOX_FAIL,
    GET_ADMIN_ATTESTATION_HISTORY_SUCCESS,
    GET_ADMIN_ATTESTATION_HISTORY_FAIL,
    ADMIN_ATTESTATION_DECISION_SUCCESS,
    ADMIN_ATTESTATION_DECISION_FAIL,

    // Download
    DOWNLOAD_ATTESTATION_PDF_SUCCESS,
    DOWNLOAD_ATTESTATION_PDF_FAIL,
    DOWNLOAD_ATTESTATION_REQUEST_PDF_SUCCESS,
    DOWNLOAD_ATTESTATION_REQUEST_PDF_FAIL,
} from "../actions/attestationsActions";

const asString = (v) => {
    if (v === null || v === undefined) return "";
    if (typeof v === "string") return v;
    try { return JSON.stringify(v); } catch (e) { return String(v); }
};

const initialState = {
    loading: false,
    error: "",
    message: "",

    // Paramétrage: liste des attestations
    attestations: [],

    // Workflow demandes
    myRequests: [],
    managerInbox: [],
    managerHistory: [],
    adminInbox: [],
    adminHistory: [],

    // Download status (optionnel)
    lastDownloadOk: false,
};

export default function attestationsReducer(state = initialState, action) {
    switch (action.type) {
        case SET_ATTESTATIONS_LOADING:
            return { ...state, loading: !!action.payload };

        case CLEAR_ATTESTATIONS_MESSAGE:
            return { ...state, error: "", message: "" };

        // ===================== PARAMETRAGE =====================
        case FETCH_ATTESTATIONS_SUCCESS:
            return { ...state, attestations: action.payload || [], error: "", message: "" };

        case FETCH_ATTESTATIONS_FAIL:
            return { ...state, error: asString(action.payload), message: "" };

        case CREATE_ATTESTATION_SUCCESS:
            return { ...state, attestations: [action.payload, ...(state.attestations || [])] };

        case CREATE_ATTESTATION_FAIL:
            return { ...state, error: asString(action.payload), message: "" };

        case UPDATE_ATTESTATION_SUCCESS:
            return {
                ...state,
                attestations: (state.attestations || []).map((a) =>
                    String(a.id) === String(action.payload?.id) ? action.payload : a
                ),
                error: "",
                message: "Attestation mise à jour",
            };

        case UPDATE_ATTESTATION_FAIL:
            return { ...state, error: asString(action.payload), message: "" };

        case DELETE_ATTESTATION_SUCCESS:
            return {
                ...state,
                attestations: (state.attestations || []).filter((a) => String(a.id) !== String(action.payload)),
                error: "",
                message: "Attestation supprimée",
            };

        case DELETE_ATTESTATION_FAIL:
            return { ...state, error: asString(action.payload), message: "" };

        // ===================== WORKFLOW DEMANDES =====================
        case GET_MY_ATTESTATION_REQUESTS_SUCCESS:
            return { ...state, myRequests: action.payload || [], error: "", message: "" };

        case GET_MY_ATTESTATION_REQUESTS_FAIL:
            return { ...state, error: asString(action.payload), message: "" };

        case CREATE_ATTESTATION_REQUEST_SUCCESS:
            return {
                ...state,
                myRequests: [action.payload, ...(state.myRequests || [])],
                error: "",
                message: "Demande envoyée",
            };

        case CREATE_ATTESTATION_REQUEST_FAIL:
            return { ...state, error: asString(action.payload), message: "" };

        case CANCEL_ATTESTATION_REQUEST_SUCCESS:
            return {
                ...state,
                myRequests: (state.myRequests || []).map((r) =>
                    String(r.id) === String(action.payload?.id) ? { ...r, status: "CANCELLED" } : r
                ),
                message: "Demande d'attestation annulée avec succès",
                error: "",
            };

        case CANCEL_ATTESTATION_REQUEST_FAIL:
            return { ...state, error: asString(action.payload), message: "" };

        case UPDATE_ATTESTATION_REQUEST_SUCCESS:
            return {
                ...state,
                myRequests: (state.myRequests || []).map((r) =>
                    String(r.id) === String(action.payload?.id) ? action.payload : r
                ),
                message: "Demande d'attestation modifiée avec succès",
                error: "",
            };

        case UPDATE_ATTESTATION_REQUEST_FAIL:
            return { ...state, error: asString(action.payload), message: "" };

        case GET_MANAGER_ATTESTATION_INBOX_SUCCESS:
            return { ...state, managerInbox: action.payload || [], error: "", message: "" };

        case GET_MANAGER_ATTESTATION_INBOX_FAIL:
            return { ...state, error: asString(action.payload), message: "" };

        case GET_MANAGER_ATTESTATION_HISTORY_SUCCESS:
            return { ...state, managerHistory: action.payload || [], error: "", message: "" };

        case GET_MANAGER_ATTESTATION_HISTORY_FAIL:
            return { ...state, error: asString(action.payload), message: "" };

        case MANAGER_ATTESTATION_DECISION_SUCCESS:
            return { ...state, message: "Décision enregistrée", error: "" };

        case MANAGER_ATTESTATION_DECISION_FAIL:
            return { ...state, error: asString(action.payload), message: "" };

        case GET_ADMIN_ATTESTATION_INBOX_SUCCESS:
            return { ...state, adminInbox: action.payload || [], error: "", message: "" };

        case GET_ADMIN_ATTESTATION_INBOX_FAIL:
            return { ...state, error: asString(action.payload), message: "" };

        case GET_ADMIN_ATTESTATION_HISTORY_SUCCESS:
            return { ...state, adminHistory: action.payload || [], error: "", message: "" };

        case GET_ADMIN_ATTESTATION_HISTORY_FAIL:
            return { ...state, error: asString(action.payload), message: "" };

        case ADMIN_ATTESTATION_DECISION_SUCCESS:
            return { ...state, message: "Décision enregistrée", error: "" };

        case ADMIN_ATTESTATION_DECISION_FAIL:
            return { ...state, error: asString(action.payload), message: "" };

        case DOWNLOAD_ATTESTATION_PDF_SUCCESS:
        case DOWNLOAD_ATTESTATION_REQUEST_PDF_SUCCESS:
            return { ...state, lastDownloadOk: true, error: "", message: "" };

        case DOWNLOAD_ATTESTATION_PDF_FAIL:
        case DOWNLOAD_ATTESTATION_REQUEST_PDF_FAIL:
            return { ...state, lastDownloadOk: false, error: asString(action.payload), message: "" };

        default:
            return state;
    }
}
